import React from 'react'
import styled from 'styled-components'
import {withState} from 'recompose'
import GrayArrow from '../../../../static/arrowLeftGray.svg'
import TranslateText from 'src/text/modal'


const Option = styled.option`
  font-size: 18px;
  padding: 10px 20px 10px 10px;
`;

function Mobile({cards, selected, setSelected}) {
  const firstOptionIsSelected = selected === 'Все';

  return (
    <TranslateText
      id="search_tabs__all"
      hideTooltip
      render={text => {
        return (
          <Select
            label={
              !firstOptionIsSelected ?
                `${selected} (${cards[selected].length})`
                :
                `${text} (${(cards ? Object.keys(cards) : []).reduce((r, e) => r + cards[e].length, 0)})` 
            }
            value={selected}
            onChange={({ target: { value }}) => setSelected(value)}
          >
            {(['Все', ...(cards ? Object.keys(cards) : [])]).map((value, i) => {
              return (
                <Option
                  value={value}
                  key={i}
                >
                  {i !== 0 ?
                    `${value} (${cards[value].length})`
                    :
                    `${text} (${(cards ? Object.keys(cards) : []).reduce((r, e) => r + cards[e].length, 0)})`
                  }
                </Option>
              );
            })}
          </Select>
        );
      }}
    />
    // <Select
    //   label={format(selected, cards)}
    //   value={selected}
    //   onChange={(e) => setSelected(e.target.value)}
    // >
    //   {
    //     (['Все', ...(cards ? Object.keys(cards) : [])]).map((c, i) => {
    //       return (
    //         <Option value={c}>{format(c, cards)}</Option>
    //       )
    //     })
    //   }
    // </Select>
  );
}


const Container = styled.div`
  position: relative;
  height: 42px;
  line-height: 42px;
  font-size: 18px;
  border: 1px solid rgb(220, 220, 220);
`

const OnTop = styled.div`
  padding-top: 0;
  padding-left: 8px;
  position: relative;
  width: 100%;
  height: 100%;
  
  & > img {
    position: absolute;
    top: 13px;
    right: 15px;
  }
`

const Dropdown = styled.select`
  position: absolute;
  left: 0;
  top: 0;
  background: white;
  color: black;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  z-index: 100;
`

const Select = withState('clicked', 'setClicked', false)(({children, value, onChange, label, hover, setHover, disabled, style, imgNotFixed,}) => {
  return (
    <Container>
      <Dropdown
        value={value}
        onChange={onChange}
        disabled={disabled}
      >
        {children}
      </Dropdown>
      <OnTop>
        {label}
        <img
          style={{
            transform: 'rotate(-90deg)',
          }}
          src={GrayArrow}
        />
      </OnTop>
    </Container>
  )
})

export default Mobile



// WEBPACK FOOTER //
// ./src/finwhale/common/search/category-type/Mobile.js